const APIS = {
    STAFF: "/fleetservice/api/staff/",
    USER: "/fleetservice/api/user/",
    USER_PROFILE: "/fleetservice/api/user-profile/",
    CLIENT_TYPE:"/fleetservice/api/client-type/",
    VEHILCE:"/fleetservice/api/vehicle/",
    VEHILCE_TYPE:"/fleetservice/api/vehicle-type/",
    VEHILCE_CATEGORY:"/fleetservice/api/vehicle-category/",
  };
  
  export default APIS;